<template>
  <div>
    <div class="search">
      <el-form :model="queryParams" ref="queryForm">
        <div class="form-box">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入名称"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </div>
      </el-form>
      <div>
        <a href="javascript:;" class="btn btn-search" @click="handleQuery">
          <img src="../../../../assets/tableImg/search.svg" alt="" />{{ $t('search.search') }}</a
        >
        <a href="javascript:;" class="btn btn-reset" @click="resetQuery">
          <img src="../../../../assets/tableImg/reset.svg" alt="" />{{ $t('search.reset') }}</a
        >
      </div>
    </div>

    <div class="content-box">
      <div>
        <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
      </div>
      <div class="public-el-table">
        <el-table
          v-loading="loading"
          :data="myProcessList"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            label="流程编号"
            align="center"
            prop="procInsId"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="流程名称"
            align="center"
            prop="procDefName"
            :show-overflow-tooltip="true"
          />
          <el-table-column label="流程类别" align="center" prop="category" width="100px" />
          <el-table-column label="流程版本" align="center" width="80px">
            <template slot-scope="scope">
              <el-tag size="medium">v{{ scope.row.procDefVersion }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="提交时间" align="center" prop="createTime" width="180" />
          <el-table-column label="流程状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.finishTime == null" size="mini">进行中</el-tag>
              <el-tag type="success" v-if="scope.row.finishTime != null" size="mini">已完成</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="耗时" align="center" prop="duration" width="180" />
          <el-table-column label="当前节点" align="center" prop="taskName" />
          <el-table-column label="办理" align="center">
            <template slot-scope="scope">
              <label v-if="scope.row.assigneeName"
                >{{ scope.row.assigneeName }}
                <el-tag type="info" size="mini">{{ scope.row.deptName }}</el-tag></label
              >
              <label v-if="scope.row.candidate">{{ scope.row.candidate }}</label>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    icon="el-icon-tickets"
                    @click.native="handleFlowRecord(scope.row)"
                  >
                    详情
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="el-icon-circle-close"
                    @click.native="handleStop(scope.row)"
                  >
                    取消申请
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="el-icon-delete"
                    @click.native="handleDelete(scope.row)"
                    v-hasPermi="['system:deployment:remove']"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 发起流程 -->
    <el-dialog :title="title" :visible.sync="open" width="60%" append-to-body>
      <el-form
        :model="queryProcessParams"
        ref="queryProcessForm"
        :inline="true"
        v-show="showSearch"
        label-width="68px"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="queryProcessParams.name"
            placeholder="请输入名称"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleProcessQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetProcessQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="processLoading" fit :data="definitionList" border size="mini">
        <el-table-column label="流程名称" align="center" prop="name" />
        <el-table-column label="流程版本" align="center">
          <template slot-scope="scope">
            <el-tag size="medium">v{{ scope.row.version }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="流程分类" align="center" prop="category" />
        <el-table-column
          label="操作"
          align="center"
          width="300"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit-outline"
              @click="handleStartProcess(scope.row)"
              >发起流程</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :selectionShow="false"
        :multipleSelection="ids"
        :total="processTotal"
        :page.sync="queryProcessParams.pageNum"
        :limit.sync="queryProcessParams.pageSize"
        @pagination="listDefinition"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>
  // import {
  //   getDeployment,
  //   delDeployment,
  //   addDeployment,
  //   updateDeployment,
  //   exportDeployment,
  //   flowRecord
  // } from "@/api/flowable/finished";
  // import { myProcessList,stopProcess } from "@/api/flowable/process";
  // import {listDefinition} from "@/api/flowable/definition";
  import pagination from '../../../../components/pagination';
  import buttonItem from '../../../../components/ButtonItem';

  export default {
    name: 'Deploy',
    components: {
      pagination,
      buttonItem,
    },
    data() {
      return {
        // 遮罩层
        loading: false,
        processLoading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        // 显示搜索条件
        showSearch: true,
        multiple: true,
        // 总条数
        total: 0,
        processTotal: 0,
        // 我发起的流程列表数据
        myProcessList: [],
        // 弹出层标题
        title: '',
        // 是否显示弹出层
        open: false,
        src: '',
        definitionList: [],
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          name: null,
          category: null,
          key: null,
          tenantId: null,
          derivedFrom: null,
          derivedFromRoot: null,
          parentDeploymentId: null,
          engineVersion: null,
        },
        // 查询参数
        queryProcessParams: {
          pageNum: 1,
          pageSize: 10,
          name: null,
          category: null,
          key: null,
          tenantId: null,
          deployTime: null,
          derivedFrom: null,
          derivedFromRoot: null,
          parentDeploymentId: null,
          engineVersion: null,
        },
        // 表单参数
        form: {},
        // 表单校验
        rules: {},
        menuButtonList: [],
      };
    },
    created() {
      this.getList();
      this.getButtons().then((e) => {
        this.menuButtonList = e;
      });
    },
    methods: {
      /** 查询流程定义列表 */
      getList() {
        this.loading = true;
        this.$axios.get('/maindata/flowable/task/myProcess', this.queryParams).then((response) => {
          this.myProcessList = response.data.data.records;
          this.total = response.data.data.total;
          this.loading = false;
        });
      },
      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },
      // 表单重置
      reset() {
        this.form = {
          id: null,
          name: null,
          category: null,
          key: null,
          tenantId: null,
          deployTime: null,
          derivedFrom: null,
          derivedFromRoot: null,
          parentDeploymentId: null,
          engineVersion: null,
        };
        this.resetForm('form');
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.pageNum = 1;
        this.getList();
      },
      /** 重置按钮操作 */
      resetQuery() {
        // this.resetForm("queryForm");
        this.queryParams.name = '';
        this.handleQuery();
      },
      /** 搜索按钮操作 */
      handleProcessQuery() {
        this.queryProcessParams.pageNum = 1;
        this.listDefinition();
      },
      /** 重置按钮操作 */
      resetProcessQuery() {
        this.queryProcessParams.name = '';
        this.handleProcessQuery();
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map((item) => item.id);
        this.single = selection.length !== 1;
        this.multiple = !selection.length;
      },
      /** 新增按钮操作 */
      handleAdd() {
        this.open = true;
        this.title = '发起流程';
        this.listDefinition();
      },
      listDefinition() {
        this.$axios
          .get('/maindata/flowable/definition/list', this.queryProcessParams)
          .then((response) => {
            this.definitionList = response.data.data.records;
            this.processTotal = response.data.data.total;
            this.processLoading = false;
          });
      },
      /**  发起流程申请 */
      handleStartProcess(row) {
        this.$router.push({
          path: '/flowable/record',
          query: {
            deployId: row.deploymentId,
            procDefId: row.id,
            finished: true,
          },
        });
      },
      /**  取消流程申请 */
      handleStop(row) {
        const params = {
          instanceId: row.procInsId,
        };
        this.stopProcess(params).then((res) => {
          this.msgSuccess(res.msg);
          this.getList();
        });
      },
      /** 流程流转记录 */
      handleFlowRecord(row) {
        this.$router.push({
          path: '/flowable/task/record/index',
          query: {
            procInsId: row.procInsId,
            deployId: row.deployId,
            taskId: row.taskId,
            finished: false,
          },
        });
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        this.reset();
        const id = row.id || this.ids;
        this.getDeployment(id).then((response) => {
          this.form = response.data;
          this.open = true;
          this.title = '修改流程定义';
        });
      },
      /** 提交按钮 */
      submitForm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.form.id != null) {
              this.updateDeployment(this.form).then(() => {
                this.msgSuccess('修改成功');
                this.open = false;
                this.getList();
              });
            } else {
              this.addDeployment(this.form).then(() => {
                this.msgSuccess('新增成功');
                this.open = false;
                this.getList();
              });
            }
          }
        });
      },
      /** 删除按钮操作 */
      handleDelete(row) {
        const ids = row.id || this.ids;
        this.$confirm('是否确认删除流程定义编号为"' + ids + '"的数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function () {
            return this.delDeployment(ids);
          })
          .then(() => {
            this.getList();
            this.msgSuccess('删除成功');
          });
      },
      /** 导出按钮操作 */
      handleExport() {
        const queryParams = this.queryParams;
        this.$confirm('是否确认导出所有流程定义数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function () {
            return this.exportDeployment(queryParams);
          })
          .then((response) => {
            this.download(response.msg);
          });
      },
      clickEvent(item) {
        switch (item) {
          case 'add':
            this.handleAdd();
            break;
          case 'delete':
            // this.handleDelete(this.ids, 'selection')
            break;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .search {
    margin-bottom: 10px;
    padding: 0 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form-box {
      display: flex;
      .el-form-item {
        width: 320px;
        margin-left: 20px;
        margin-top: 18px;
        ::v-deep .el-form-item__label {
          width: 80px;
        }
        ::v-deep .el-form-item__content {
          margin-left: 80px;
        }
        ::v-deep .el-select {
          width: 100%;
        }
        ::v-deep .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
      }
      .item {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .btn {
      width: 90px;
      height: 30px;
      display: inline-block;
      line-height: 30px;
      text-align: center;
      border-radius: 3px;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
    }

    .btn-search {
      background-color: #409eff;
      color: #ffffff;
    }
    .btn-reset {
      background-color: #ffffff;
      color: #409eff;
      border: 1px solid #e4e6eb;
    }
  }

  .content-box {
    padding: 20px 30px;
    background-color: #ffffff;
  }
  ::v-deep .el-dialog__body {
    padding: 20px 30px;
  }
  ::v-deep .el-tag {
    color: #00b400;
    background-color: #cff4cf;
    border-color: #cff4cf;
  }
</style>
